import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

// Shared layouts
import DashboardLayout from 'layouts/Dashboard';

// Custom components
//import Notifications from './components/Notifications';

//import Password from './components/Password';
//import ListObjectives from './components/ListObjectives';
//import BusinessHours from './components/BusinessHours';
//import ClientWeighing from './components/ClientWeighing';
import QuickViewIspView from './components/QuickViewIspView';
import UserLights from './components/UserLigths';
import QuickViewFullView from './components/QuickViewFullView';

import queryString from 'query-string';

// Component styles
const styles = theme => ({
    root: {
        //Custom Styles AP
        backgroundColor: '#e7e7e7',
        /*height: '100vh'*/
    }
});

class QuickViewIspLights extends Component {
    constructor(props) {
        super(props);
        this.myCallback = this.myCallback.bind(this);
        this.state = {
            tabIndex: 0,
            props: props,
            value: 0,
            profileId: sessionStorage.getItem('profile_id'),
            listHours: [1]
        }

    }

    myCallback = (dataFromChild) => {
        this.setState({
            objectivesList: dataFromChild
        })
    }

    componentDidMount() {
        const parsed = queryString.parse(this.props.location.search);
        const active = parsed?.active ?? 0
        this.setState({value: parseInt(active)})
    }

    handleChange = (event, newValue) => {
        this.props.history.push(`/quickviewisplights?active=${newValue}`, {Graph: 1})
    };
    

    render() {
        const { classes } = this.props;
        const {value, objectivesList, profileId, listHours} = this.state;
        var displayHours = false
        var displayWeighing = false
        if(listHours.includes(parseInt(profileId)) === true){
            displayHours = true
            //displayWeighing = true
        }
        return (
            <DashboardLayout title="Vista Rápida por Isp / Semáforo" callbackFromParent={this.myCallback}>
                {objectivesList ?
                    <div className={classes.root} >
                        <AppBar position="static"  style={{ backgroundColor: '#333333' ,marginTop:"101px"}}>
                            <Tabs value={value} onChange={this.handleChange} aria-label="simple tabs example">
                                <Tab label="Vista Rápida"/>
                                <Tab label="Vista Rápida Compacta"/>
                                <Tab label="Semáforo"/>
                            </Tabs>
                        </AppBar>
                        
                        { value == 0 ?
                            <QuickViewFullView/>
                        : value == 1 ? 
                            <QuickViewIspView/>  
                        : value == 2 ? 
                            <UserLights />    
                        : null }
                    </div>
                :null}
            </DashboardLayout>
        );
    }
}

QuickViewIspLights.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(QuickViewIspLights);
